import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
`

export const InputContainer = styled.div<{ width?: string }>`
  display: flex;
  height: 100%;
  gap: 0.3rem;
  flex-direction: column;
  width: ${(props) => (props.width ? props.width : '100%')};

  > span {
    font-size: 14px;
    color: #494949;
  }

  > textarea {
    resize: none;
    min-height: 10rem;
    padding: 0.5rem;
    border: 1px solid #cecece;
    border-radius: 6px;
  }
`
